import React from 'react';
import { Button } from '@allygpo/ally-ux';
import type { AppToast } from '../../context/ToastContext';

interface NotifyOptions {
  /** Shows an Undo action; the toast closes when it is used. */
  undo?: () => void;
  /** Defaults to 4.5s. */
  life?: number;
  tone?: 'success' | 'info' | 'warn' | 'error';
}

/**
 * Short confirmation toast: "Scenario 5 added to favorites". With `undo`, it is Ally UX's neutral toast with
 * an Undo action in the message (the Toast has no per-message action slot).
 */
export const notify = (toast: React.RefObject<AppToast | null>, message: React.ReactNode, { undo, life = 4500, tone = 'success' }: NotifyOptions = {}) => {
  toast.current?.showItem({
    variant: undo ? 'neutral' : tone,
    duration: life,
    message: undo
      ? <span className="flex align-items-center u-gap-2">
          <span>{message}</span>
          <Button variant="link" onClick={() => { toast.current?.clear(); undo(); }}>Undo</Button>
        </span>
      : message,
  });
};
